import * as yup from 'yup'
import 'yup-phone'
import { verticals } from '../utils/verticals'
const phoneRegExp =
  /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/
const phoneSchema = yup.string().phone('', true, 'Invalid phone number')

export const registerBrandFormValidationSchema = yup.object().shape({
  brandType: yup.string().required('Required'),
  companyName: yup.string().required('Required'),
  brandName: yup.string().required('Required'),
  contact: yup.object({
    name: yup.string().required('Required'),
    email: yup.string().email('Invalid email').required('Required'),
    mobile: yup
      .string()
      .required('Required')
      .phone('', true, 'Invalid phone number')
      .matches(phoneRegExp, 'Invalid phone number')
  }),
  campaign: yup.object({
    name: yup.string().required('Required'),
    type: yup.string().required('Required'),
    brief: yup.string(),
    proposalDate: yup.string().required('Required'),
    start: yup.string().required('Required'),
    end: yup.string().required('Required'),
    budget: yup.string().required('Required')
  }),
  verticals: yup
    .object(
      verticals.reduce((ac, item) => {
        ac[item] = yup.boolean().nullable()
        return ac
      }, {})
    )
    .test('checkedTest', 'Select at least one vertical', verticals =>
      Object.values(verticals).includes(true)
    ),
  platforms: yup
    .object({
      fb: yup.boolean().nullable(),
      ig: yup.boolean().nullable(),
      yt: yup.boolean().nullable(),
      tiktok: yup.boolean().nullable()
    })
    .test('checkedTest', 'Select at least one platform', platforms =>
      Object.values(platforms).includes(true)
    ),
  minAge: yup
    .number()
    .typeError('Min age must be a number')
    .required('Min age is required')
    .min(0, 'Min age must be at least 0')
    .max(100, 'Min age must be at most 100')
    .test('lessThanMax', 'Min age must be less than max age', function (value) {
      const maxAge = this.parent.maxAge
      return value <= maxAge
    }),
  maxAge: yup
    .number()
    .typeError('Max age must be a number')
    .required('Max age is required')
    .min(0, 'Max age must be at least 0')
    .max(100, 'Max age must be at most 100')
    .test(
      'greaterThanMin',
      'Max age must be greater than min age',
      function (value) {
        const minAge = this.parent.minAge
        return value >= minAge
      }
    )
})

export const campaignFormValidationSchema = yup.object().shape({
  campaign: yup.object({
    name: yup.string().required('Required'),
    type: yup.string().required('Required'),
    brief: yup.string(),
    proposalDate: yup.string().required('Required'),
    start: yup.string().required('Required'),
    end: yup.string().required('Required'),
    budget: yup.string().required('Required')
  }),
  verticals: yup
    .object(
      verticals.reduce((ac, item) => {
        ac[item] = yup.boolean().nullable()
        return ac
      }, {})
    )
    .test('checkedTest', 'Select at least one vertical', verticals =>
      Object.values(verticals).includes(true)
    ),
  platforms: yup
    .object({
      fb: yup.boolean().nullable(),
      ig: yup.boolean().nullable(),
      yt: yup.boolean().nullable(),
      tiktok: yup.boolean().nullable()
    })
    .test('checkedTest', 'Select at least one platform', platforms =>
      Object.values(platforms).includes(true)
    ),
  minAge: yup
    .number()
    .typeError('Min age must be a number')
    .required('Min age is required')
    .min(0, 'Min age must be at least 0')
    .max(100, 'Min age must be at most 100')
    .test('lessThanMax', 'Min age must be less than max age', function (value) {
      const maxAge = this.parent.maxAge
      return value <= maxAge
    }),
  maxAge: yup
    .number()
    .typeError('Max age must be a number')
    .required('Max age is required')
    .min(0, 'Max age must be at least 0')
    .max(100, 'Max age must be at most 100')
    .test(
      'greaterThanMin',
      'Max age must be greater than min age',
      function (value) {
        const minAge = this.parent.minAge
        return value >= minAge
      }
    )
})

export const adminCampaignFormValidationSchema = yup.object().shape({
  campaign: yup.object({
    brand: yup.string().required('Required'),
    name: yup.string().required('Required'),
    type: yup.string().required('Required'),
    proposalDate: yup.string().required('Required'),
    start: yup.string().required('Required'),
    end: yup.string().required('Required'),
    budget: yup.string().required('Required')
  }),
  verticals: yup
    .object(
      verticals.reduce((ac, item) => {
        ac[item] = yup.boolean().nullable()
        return ac
      }, {})
    )
    .test('checkedTest', 'Select at least one vertical', verticals =>
      Object.values(verticals).includes(true)
    ),
  platforms: yup
    .object({
      fb: yup.boolean().nullable(),
      ig: yup.boolean().nullable(),
      yt: yup.boolean().nullable(),
      tiktok: yup.boolean().nullable()
    })
    .test('checkedTest', 'Select at least one platform', platforms =>
      Object.values(platforms).includes(true)
    ),
  minAge: yup
    .number()
    .typeError('Min age must be a number')
    .required('Min age is required')
    .min(0, 'Min age must be at least 0')
    .max(100, 'Min age must be at most 100')
    .test('lessThanMax', 'Min age must be less than max age', function (value) {
      const maxAge = this.parent.maxAge
      return value <= maxAge
    }),
  maxAge: yup
    .number()
    .typeError('Max age must be a number')
    .required('Max age is required')
    .min(0, 'Max age must be at least 0')
    .max(100, 'Max age must be at most 100')
    .test(
      'greaterThanMin',
      'Max age must be greater than min age',
      function (value) {
        const minAge = this.parent.minAge
        return value >= minAge
      }
    )
})

export const brandFormValidation = yup.object().shape({
  brandType: yup.string().required('Required'),
  brandName: yup.string().required('Required'),
  contact: yup.object({
    name: yup.string().required('Required'),
    email: yup.string().email('Invalid email').required('Required'),
    mobile: yup
      .string()
      .required('Required')
      .phone('', true, 'Invalid phone number')
      .matches(phoneRegExp, 'Invalid phone number')
  }),
  billing: yup.object({
    name: yup.string(),
    email: yup.string().email('Invalid email'),
    mobile: yup
      .string()
      .test('test-phone', 'Invalid phone number', function (value) {
        if (value) return phoneSchema.isValidSync(value)
        return true
      })
  }),
  bir: yup.string()
})
